<template>
  <v-card class="mb-1 ticket grow">
    <v-card-text :style="{ color: status }" style="border-left: 5px solid">
      <v-layout>
        <v-flex style="word-break: break-word">
          <div
            v-if="['studio7', 'ticket2', 'ustore'].includes(selectedBot.theme)"
            class="caption pb-1"
          >
            TICKET ID: {{ ticket.id }}
          </div>
          <div
            v-if="['seagull'].includes(selectedBot.theme) || PAGE.MTC.includes(selectedBot.pageid)"
            class="font-weight-bold pb-1"
          >
            TICKET ID: {{ ticket.id }}
          </div>
          <div class="font-weight-bold">{{ ticket.subject }}</div>
          <div class="caption">{{ ticket.details }}</div>
        </v-flex>
        <template v-if="!loadingAgentData">
          <Ticket2Edit
            v-if="['studio7', 'ticket2', 'ustore'].includes(selectedBot.theme)"
            :ref="`editticket_${ticket.id}`"
            :key="ticket.id"
            v-model="ticket"
            :livechat="true"
            :type="'edit'"
            :loading="loading"
            @editTicket="onEditTicket"
          >
          </Ticket2Edit>
          <edit-ticket-monix
            v-else-if="isMonix"
            :ref="`editticket_${ticket.id}`"
            :key="ticket.id"
            v-model="ticket"
            :livechat="true"
            :type="'edit'"
            :loading="loading"
            @editTicket="onEditTicket"
          ></edit-ticket-monix>
          <edit-ticket-only
            v-else
            v-model="ticket"
            :livechat="true"
            :loading="loading"
            @editTicket="onEditTicket"
          ></edit-ticket-only>
        </template>
      </v-layout>
      <v-layout>
        <v-flex>
          <div class="caption grey--text">
            {{ ticket.starttime | DateFormat('DD/MM/YYYY HH:mm') }}
          </div>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-chip disabled class="white--text" small :color="status">{{ ticket.status }}</v-chip>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import EditTicketOnly from '@/components/view/template/ticket/EditTicket.vue'
import Ticket2Edit from '@/components/view/ticket2/management/TicketEdit.vue'
import EditTicketMonix from '@/components/view/template/ticket/EditTicketMonix.vue'
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page.js'

export default {
  components: {
    EditTicketOnly,
    EditTicketMonix,
    Ticket2Edit
  },
  props: ['value', 'pageid'],
  data() {
    return {
      loading: false,
      ticket: this.value
    }
  },
  computed: {
    ...mapGetters({
      isMonix: 'isMonix',
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      loadingAgent: 'getLoadingAgent'
    }),
    PAGE() {
      return PAGE
    },
    loadingAgentData() {
      return this.loadingAgentGroup || this.loadingAgentSubGroup || this.loadingAgent
    },
    status() {
      switch (this.ticket.status.trim().toLowerCase()) {
        case 'pending':
          return '#fb8c00'
        case 'closed':
          return '#e0e0e0'
        case 'cancelled':
          return '#ff5252'
        case 'cancelled by customer':
          return '#fd87ee'
        case 'answered':
          return '#2196f3'
        case 'open':
          return '#4CAF50'
        case 'success':
          return '#e0e0e0'
        default:
          return ''
      }
    }
  },
  methods: {
    async onEditTicket(ticket) {
      this.ticket = ticket
      this.$emit('editTicketSuccess', ticket)
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket {
  &.grow {
    z-index: 6;
    transition: all 0.2s ease-in-out;
  }
  &.grow:hover {
    transform: scale(1.02);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/TicketItem.vue